/* eslint-disable */
import { PublisherThemeConfigProvider, PublisherThemeExtendedChakraProvider } from "theme";
import { BASE_DOMAIN } from "env";
import "../legal-styles.css";

const TOS_URL = `https://widget.${BASE_DOMAIN}/ui/terms-of-service`;
const PRIVACY_URL = `https://widget.${BASE_DOMAIN}/ui/privacy-policy`;

export const TermsOfServiceContent = () => {
  return (
    <section className="py-40-m-30 tos legalese">
      <div className="section-container tos w-container">
        <div className="center">
          <h1 className="legal-page-h1">
            <strong>Tilia LLC User Terms of Service</strong>
            <br />
          </h1>
        </div>
        <aside className="policy-rte w-richtext">
          <p>
            <strong>Effective July 29, 2024</strong>
          </p>
          <p>
            These Terms of Service (&quot;<strong>Terms</strong>
            &quot;) are a legal agreement between you (&quot;User,&quot;&quot;you,&quot;or
            &quot;your &quot;) andTilia LLC (&quot;<strong>Tilia</strong>
            ,&quot;&quot;<strong>we</strong>
            ,&quot;&quot;our,&quot;or &quot;us &quot;) that govern your use of the Tilia Service (as
            defined below).
          </p>
          <p>
            As used in these Terms, the &quot;<strong>Tilia Service</strong>
            &quot;refers to Tilia &#x27;s products and services, as well as Tilia &#x27;s website
            and any software, programs, documentation, tools, internet-based services, components,
            and any updates (including software maintenance, service information, help content, bug
            fixes or maintenance releases) provided to you by Tilia, directly or indirectly, any of
            which may be provided from time to time by an affiliate of Tilia to the extent permitted
            by applicable law.
          </p>
          <p>
            <strong>
              By registering for an Tilia Account (as defined below) and/or accessing or otherwise
              using any portion of the Tilia Service, you agree to be bound by these Terms.{" "}
            </strong>
          </p>
          <p>
            <strong>
              Please read all provisions of these Terms carefully. If you do not agree to these
              Terms, you may not register for an Tilia Account or otherwise access or use any
              portion of the Tilia Service. THESE TERMS CONTAIN AN ARBITRATION PROVISION THAT
              AUTHORIZES EITHER PARTY TO ELECT MANDATORY AND BINDING ARBITRATION OF CERTAIN
              DISPUTES. THE TERMS OF THE ARBITRATION PROVISION ARE SET FORTH IN SECTION 13 BELOW,
              ENTITLED &quot;DISPUTE RESOLUTION AND ARBITRATION.&quot;PLEASE READ THIS ARBITRATION
              PROVISION CAREFULLY.
            </strong>
          </p>
          <p>
            The Tilia Service is offered through Tilia’s integrations with online platforms (each, a
            &quot;<strong>Platform</strong>
            &quot;) that are offered by third parties (each, a &quot;<strong>Publisher</strong>
            &quot;). Access to all or a portion of the Tilia Service through these Platforms and
            Publishers may be available or discontinued at the sole discretion of Tilia. You agree
            that your use of the Platform through which you access the Tilia Service is governed by
            the relevant Publisher &#x27;s end user license agreement and/or terms of use,
            including, without limitation, password and account security policies (collectively, the
            &quot;<strong>Platform TOS</strong>
            &quot;). We do not assume any responsibility for the content, policies or practices of
            any Platform, Publisher or other third party, including any Platform TOS, and you hereby
            agree that we are not liable for any loss arising from your use of any Platform, any act
            or omission of any Publisher or other third party, or the terms of any Platform TOS.
            These Terms incorporate by reference all policies, guidelines, notices, representations,
            and other content regarding the Tilia Service that are published publicly at{" "}
            <a href="https://tilia.io" target="_blank">www.tilia.io</a>&nbsp;
            (&quot;<strong>Website</strong>
            &quot;). In the event of any material conflict or inconsistency between these Terms and
            any such policies, guidelines, notices, these Terms prevail with respect to the
            provision of the Tilia Service.
          </p>
          <p>
            These Terms contain the above provisions and the following  sections. You may jump
            directly to any section by selecting the appropriate link below. The headings and
            subheadings are for reference only and do not limit the scope of each section.
            Underlined words in these Terms hyperlink to the relevant information.
          </p>
          <ol role="list">
            <li>
              <a href="#tilia-service">
                <strong>The Tilia Service</strong>
              </a>
            </li>
            <li>
              <a href="#our-relationship-with-you">
                <strong>Our Relationship with You</strong>
              </a>
            </li>
            <li>
              <a href="#payment-processing-service">
                <strong>Payment Processing</strong>
              </a>
            </li>
            <li>
              <a href="#stored-value-balance">
                <strong>Stored Value Balances</strong>
              </a>
            </li>
            <li>
              <a href="#digital-tokens">
                <strong>Digital Tokens</strong>
              </a>
            </li>
            <li>
              <a href="#disbursements">
                <strong>Disbursements</strong>
              </a>
            </li>
            <li>
              <a href="#intellectual-property">
                <strong>Intellectual Property and Licenses </strong>
              </a>
            </li>
            <li>
              <a href="#communications">
                <strong>Communications</strong>
              </a>
            </li>
            <li>
              <a href="#term-and-termination">
                <strong>Term and Termination</strong>
              </a>
            </li>
            <li>
              <a href="#fees">
                <strong>Fees</strong>
              </a>
            </li>
            <li>
              <a href="#customer-complaints">
                <strong>Customer Complaints – Money Transmission Activity</strong>
              </a>
            </li>
            <li>
              <a href="#releases-disclaimers-liability">
                <strong>Releases, Disclaimers, Liability Limits and Identification</strong>
              </a>
            </li>
            <li>
              <a href="#dispute-resolution">
                <strong>Dispute Resolution and Arbitration</strong>
              </a>
            </li>
            <li>
              <a href="#general-provisions">
                <strong>General Provisions</strong>
              </a>
            </li>
          </ol>
          <h2 id="tilia-service">
            <strong>1. The Tilia Service</strong>
          </h2>
          <p>The Tilia Service is designed to allow you to: </p>
          <blockquote>
            a) make payments to the Publisher and other third parties supported by the Publisher for
            digital goods and services (“<strong>Digital Goods</strong>
            ”);
          </blockquote>
          <blockquote>
            b) use issued tokens on a Platform to use or access features or content within a
            Publisher’s Platform;
          </blockquote>
          <blockquote>
            c) hold and load funds/value in a Stored Value Balance (as defined below, which may be
            in the form of USD or Earned Tokens) as compensation from the Publisher on whose
            Platform you create and sell content or otherwise enhance the value and experience of
            the Platform (such creators referred to hereunder as “Creators,” a subset of Users);{" "}
          </blockquote>
          <blockquote>
            d) facilitate the use of in-Platform content, and access other related services within a
            Platform; and,
          </blockquote>
          <blockquote>
            e) receive funds from Publishers as part of its rewards or revenue sharing programs, if
            applicable.{" "}
          </blockquote>
          <p>
            While the Tilia Service is integrated into certain selected Platforms, the Tilia Service
            is offered by Tilia and not by the Publisher of the relevant Platform. Tilia will
            provide services to the Publisher to enable it to accept card payments by you to it, so
            that you can, for example, (i) pay the Publisher for subscriptions; (ii) purchase
            in-Platform tokens (known as Purchased Tokens) which may be used to pay for in-Platform
            Digital Goods from the Publisher; (iii) make other payments to the Publisher, or, (iv)
            remit funds on behalf of the Publisher as part of its rewards or revenue sharing
            programs, if applicable.
          </p>
          <p>
            Tilia is not responsible for the provision of the Platform itself or any experience
            within the Platform—just the Tilia Service. This means, for example, that Tilia is not
            responsible or liable for the Digital Goods offered and provided by Publishers to you.{" "}
          </p>
          <p>
            Tilia does not have control of, or liability for, any Publisher or other third party
            content that is accessed using the Tilia Service or any products or services that are
            paid for using the Tilia Service. In the event of any conflict between the relevant
            Platform TOS and these Terms, these Terms will govern as between you and Tilia, and with
            respect to the Tilia Service.{" "}
          </p>
          <p>
            As the different features of the Tilia Service that are enabled for a particular
            Platform will be determined by the relevant Publisher and Tilia, the Platform TOS
            applicable to that Platform may use slightly different terminology to refer to the Tilia
            Service features available through the Platform.{" "}
          </p>
          <p>
            In accordance with and to the fullest extent permitted by applicable laws, Tilia has the
            right to change, limit access to, or eliminate any aspect(s), feature(s) or
            functionality of the Tilia Service in its sole discretion at any time without notice,
            and Tilia makes no commitment (express or implied) to offer, maintain, continue, or
            permit access to any aspect of the Tilia Service. Additionally, Tilia can authorize or
            decline a transaction effected with the Tilia Service for whatever reason (e.g., for
            suspected fraud or insufficient funds), restrict the number of transactions you may
            engage in over a period of time, or limit the amount of any transaction (either
            individually or in the aggregate over a period of time).
          </p>
          <h2 id="our-relationship-with-you">
            <strong>2. Our Relationship with You</strong>
          </h2>
          <h3>
            <strong>2.1. Eligibility</strong>
          </h3>
          <p>
            In order to be eligible to access and use the Tilia Service, youmust (i) be eighteen
            (18) years of age or older, (ii) have the legal ability toenter into and be bound by
            these Terms and the relevant Platform TOS, (iii) have accepted the Platform TOS
            applicable to the particular Platform through which you are accessing the Tilia Service
            and remain eligible to access and use such Platform, (iv) comply with these Terms, and
            (iv) establish and maintain an active and valid user account with Tilia (“
            <strong>Tilia Account</strong>
            ”).
          </p>
          <p>
            To create a Tilia Account and/or access certain features or functionality of the Tilia
            Service, we may require you to provide us with certain personal information and
            documentation that will enable us to identify you and otherwise comply with applicable
            law (please see Section 2.4 Identity Verification below). For further details on what we
            may collect, please see our <a href={PRIVACY_URL} target="_blank">Privacy Policy</a>.
          </p>
          <p>
            You agree to provide accurate, current and complete information about yourself and to
            use the provided Tilia Account management tools to keep that information accurate,
            current and complete. We may request additional information from you in the future. We
            will review and validate the information you provide to us to ensure we have a
            reasonable belief of your identity. This is in accordance with our obligations under
            applicable anti-money laundering regulations.{" "}
          </p>
          <p>
            We reserve the right to refuse, suspend, limit or terminate your access to all or a
            portion of the Tilia Service at any time in our sole discretion.
          </p>
          <p>
            As the features and functionality of the Tilia Service provided through a particular
            Platform are specific to that Platform, you may need to create and maintain a Tilia
            Account in connection with each such Platform through which you wish to access the Tilia
            Service. Your Tilia Account may be in addition to any account you must maintain with a
            Publisher or other third party to use a Platform or access a payment method in
            connection with the Tilia Service, and terms and conditions applicable to those accounts
            in no way modify, lessen, or alter your obligations to Tilia under these Terms.
          </p>
          <p>
            You may not sell, transfer or assign your Tilia Account (including any associated Stored
            Value Balance, as defined in Section 4 below) or any associated contractual rights,
            licences or obligations, to any third party without the prior written consent of Tilia.
          </p>
          <h3>
            <strong>2.2. Acceptable Use</strong>
          </h3>
          <p>
            When using the Tilia Service and/or Website, you must always do so for legal, authorized
            and acceptable purposes.{" "}
          </p>
          <p>
            Your use and access of the Tilia Service is your choice and you are solely responsible
            for compliance with applicable local laws regarding your online conduct and acceptable
            content. You may not use the Tilia Service in a manner that conflicts with these Terms.
          </p>
          <p>
            When you do business with us, you agree to comply with all applicable laws, regulations
            or ordinances, and orders of governmental and governing authorities, including data
            protection and anti-money laundering laws. You agree not to use your Tilia Account or
            other portion of the Tilia Service for any unlawful purpose.
          </p>
          <p>When using the Tilia Service and/or Website, you will not:</p>
          <ul role="list">
            <li>
              use them in any unlawful manner, for any unlawful purpose, or in any manner
              inconsistent with or contravening these Terms;
            </li>
            <li>
              violate or infringe the rights of Tilia, any of its group companies, our users, or
              other third parties, including rights in respect of privacy, intellectual property, or
              other proprietary rights;
            </li>
            <li>provide false, inaccurate or misleading information; </li>
            <li>
              engage in any potentially fraudulent or suspicious activity and/or transactions,
              including receiving money which may be fraudulent or adding money to your Tilia
              Account which may be linked to criminal activities;
            </li>
            <li>
              refuse to cooperate with an investigation or provide any information we request,
              including with respect to verifying your identity;
            </li>
            <li>
              transmit any communication, material or other content that is illegal, obscene,
              defamatory, threatening, intimidating, harassing, hateful, racially or ethnically
              offensive, or which could instigate or encourage conduct that would be illegal or
              otherwise inappropriate, including promoting violent crimes;
            </li>
            <li>impersonate someone else; </li>
            <li>seek to harm Tilia, our group companies, or any of our users or customers; or</li>
            <li>
              access, use, copy, modify, distribute, display, otherwise exploit or prepare
              derivative works based upon and of the Tilia Service in impermissible or unauthorized
              manners, or in ways that harm us, our group companies, the Tilia Service, systems,
              users, or others. In particular you must not:
            </li>
            <li className="sub-list-tos">
              reverse engineer, alter, modify, create derivative works from, decompile, or extract
              code from the Tilia Service, except to the extent permitted by law;
            </li>
            <li className="sub-list-tos">
              send, store, or transmit viruses or other harmful computer code through or onto the
              Tilia Service;
            </li>
            <li className="sub-list-tos">
              gain or attempt to gain unauthorized access to our systems or those of our group
              companies;
            </li>
            <li className="sub-list-tos">
              create accounts for the Tilia Service through unauthorized means;
            </li>
            <li className="sub-list-tos">
              collect the information of or about our users in any impermissible or unauthorized
              manner; and/or
            </li>
            <li className="sub-list-tos">
              sell, resell, rent, or charge for the use of, the Tilia Service.
            </li>
          </ul>
          <p>
            You are not permitted to use the Tilia Service if you are in, under the control of, or a
            national or resident of Cuba, Iran, North Korea, Sudan, or Syria or any other country
            subject to United States embargo, UN sanctions, the European Union or HM Treasury
            &#x27;s financial sanctions regimes (each a &quot;<strong>Sanctioned Country</strong>
            &quot;), or if you are a person on the U.S. Treasury Department &#x27;s Specially
            Designated Nationals List or the U.S. Commerce Department &#x27;s Denied Persons List,
            Unverified List, Entity List, or the EU or HM Treasury &#x27;s financial sanctions
            regime (a &quot;Sanctioned Person &quot;) or you intend to supply the Tilia Service to a
            Sanctioned Country (or a national or resident of a Sanctioned Country) or Sanctioned
            Person
          </p>
          <h3>
            <strong>2.3. Your Privacy</strong>
          </h3>
          <p>
            Protecting your privacy and your personal data is very important to Tilia. Our practices
            governing the collection and use of your personal data are detailed in our{" "}
            <a href={PRIVACY_URL} target="_blank">Privacy Policy</a>. Please review this policy before you
            provide us with your personal data in order to better understand our commitment to
            maintaining your privacy, as well as our use of your personal data.
          </p>
          <p>
            Your decision to use the Tilia Service is purely voluntary and optional. However, as
            detailed above, to use the Tilia Service, you must have a Tilia Account for which we
            require certain of your personal data to create. If you elect not to provide the
            requisite personal data, you will not be able to create a Tilia Account or access or use
            the Tilia Service.{" "}
          </p>
          <p>
            As the Tilia Service is integrated into Platforms offered by Publishers, you may be
            asked to provide certain personal data to a Publisher or other third party in connection
            with your use of a Platform. Such information is subject to the privacy policy of the
            relevant Publisher or other third party.
          </p>
          <h3>
            <strong>2.4. Identity Verification</strong>
          </h3>
          <p>
            If you use certain aspects of the Tilia Service (specifically, holding a Stored Value
            Balance), applicable law requires that Tilia verify your identity. This means that Tilia
            requires you to provide certain personal information that will enable us to accurately
            identify you.{" "}
          </p>
          <p>
            We may also ask you to provide certain documentation, e.g., driver’s license, at our
            sole discretion, at any time.  For more information on how we use this information and
            your rights in respect of such use, please see our{" "}
            <a href={PRIVACY_URL} target="_blank">Privacy Policy</a>.
          </p>
          <p>
            You may be required to provide confirmation of ownership of your email address,
            financial instruments, your source of funds and/or you may have to verify your
            information against third party databases or other sources.{" "}
          </p>
          <p>
            You authorize Tilia, directly or through third parties, to make any inquiries we
            consider necessary to validate your identity and the information you provide to us.
          </p>
          <p>
            It is your responsibility to keep us updated of changes to your information, including
            e-mail address and mobile numbers. Failure to do so may result in us being unable to:
          </p>
          <blockquote>a) contact you regarding your Tilia Account; </blockquote>
          <blockquote>b) comply with applicable laws; and/or </blockquote>
          <blockquote>c) let you know about changes to these Terms.</blockquote>
          <p>
            Tilia reserves the right to close, suspend, or limit access to your Tilia Account and/or
            the Tilia Service in the event we are unable to obtain or verify information or your
            identity.
          </p>
          <h3>
            <strong>2.5. Security</strong>
          </h3>
          <p>
            You are responsible for maintaining adequate security and control of any and all IDs,
            passwords, personal identification numbers (PINs), or any other codes that you use to
            access your Tilia Account or the Tilia Service.{" "}
          </p>
          <p>You must not allow another person to:</p>
          <blockquote>a) to use or otherwise access the Tilia Account assigned to you.</blockquote>
          <blockquote>b) use security information related to your Tilia Account; </blockquote>
          <blockquote>
            c) write down password(s) or any security information unless this is done in a way that
            would make it impossible for anyone else to recognize any of that information;{" "}
          </blockquote>
          <blockquote>
            d) disclose passwords or any security information, or otherwise make them available to
            any other person, whether verbally or by entering them in a way that allows them to be
            observed by others.
          </blockquote>
          <p>
            Any loss or compromise of your electronic device or your security details may result in
            unauthorized access to or use of your Tilia Account by third parties and the loss or
            theft of any funds and any associated accounts, including your bank account(s),
            account(s) held with payment service providers and electronic money issuers and/or
            payment card(s).{" "}
          </p>
          <p>You therefore must keep your security details safe at all times.</p>
          <p>
            You are fully responsible for all activity that occurs on your Tilia Account. Tilia is
            not responsible for transactions that are effected using your Tilia Account if someone
            accesses your Tilia Account, IDs, passwords, or other codes necessary to access your
            Tilia Account, or any losses that you may suffer therefrom.
          </p>
          <p>
            If you suspect that your Tilia Account or any of your security details have been
            compromised or if you become aware of any fraud or attempted fraud or any other security
            incident (including a cyber-security attack) affecting you and/or Tilia (together a
            &quot;<strong>Security Breach</strong>
            &quot;), you must notify us as soon as possible by email at:{" "}
            <a href="mailto:paymentsupport@tilia.io" target="_blank">paymentsupport@tilia.io</a>, or by calling us
            at: <a href="tel:+1-855-983-4646" target="_blank">(855) 983-4646</a>&nbsp;
            (international charges may apply).
          </p>
          <p>
            We are not liable for any damage or interruptions caused by any computer viruses or
            other malicious code that may affect your computer or other equipment you use to access
            the Tilia Service, or any phishing, spoofing or other attack related to your use of the
            Tilia Service. We advise the regular use of a reputable and readily available virus
            screening and prevention software. You should also be aware that SMS and email services
            are vulnerable to spoofing and phishing attacks and should use care in reviewing
            messages purporting to originate from us.
          </p>
          <h2 id="payment-processing-service">3. Payment Processing Service</h2>
          <p>
            Tilia offers a service through which you may, using payment methods supported by Tilia,
            make payments to the relevant Publisher or other users of the Platform for products or
            services offered within the Platform and/or other amounts owed to the Publisher (such
            service, the “<strong>Payment Processing Service</strong>
            ”).
          </p>
          <p>
            In offering the Payment Processing Service, Tilia’s responsibilities to you are limited
            to remitting payment successfully received by Tilia from you to the relevant Publisher
            or user. Tilia is not responsible for any product or service purchased through your use
            of the Payment Processing Service, or for the amount or validity of any amount that may
            be charged by the relevant Publisher or user.
          </p>
          <p>
            If the Payment Processing Service is enabled for a Platform that you use, you will be
            directed to a Tilia-hosted dialog box after selecting the option on the Platform to make
            a payment, at which time you will have the option to complete the transaction using one
            of the payment methods that Tilia supports. The different payment methods supported by
            the Payment Processing Service, such as credit cards, debit cards, etc., will be
            determined by Tilia in its sole discretion, and Tilia reserves the right to limit the
            payment methods made available for any particular transaction.
          </p>
          <p>
            You may need to have an existing account or other access device in order to use a
            particular payment method, or meet other specific conditions imposed by the company
            responsible for offering such payment method (each a &quot;Payment Services Provider
            &quot;or &quot;PSP &quot;). Additionally, the PSP might have its own terms and
            conditions (including a privacy policy) that also apply to you and your use of the
            relevant payment method, even when such payment method is accessed through the Payment
            Processing Service. Tilia is not responsible for any terms and conditions, privacy
            policy, other policies and procedures, or any act or omission of any PSP.
          </p>
          <p>
            In order to conduct a payment through the Payment Processing Service, you will need to
            provide your payment or account information, and any other information, required by
            Tilia and the PSP you have selected. The information required and the manner in which
            your transaction will be processed will vary depending upon the payment method you
            select. You are responsible for providing accurate transaction and payment information
            (including any relevant PSP credentials, preferences, or log-in information) in
            connection with your use of the Payment Processing Service. If you fail to provide
            accurate transaction or payment information, Tilia will not be able to complete the
            payment transaction.  You acknowledge that it is your responsibility to ensure that your
            credit or debit cards or other access devices accepted by Tilia continue to be valid and
            sufficient for such purposes and remain responsible to Tilia for the amount of any
            chargeback or returned payment. Without limiting any other rights or remedies of Tilia,
            Tilia may exercise its termination rights as provided in Section 9 of these Terms in the
            event of non-payment.
          </p>
          <p>
            Once you complete and submit the requested information to Tilia, Tilia will forward the
            relevant information you provide to the selected PSP, which will then authorize or
            decline the transaction according to its own processes and rules. If the transaction is
            authorized, the PSP will debit your account or designated funding source for the amount
            of the transaction (including any fees owed to Tilia for using the Payment Processing
            Service). Upon Tilia &#x27;s receipt of those funds from the PSP, Tilia will remit such
            amount (less any amounts owed to Tilia) to the Publisher in accordance with the payment
            terms established between Tilia and the Publisher or to the other user of the Platform.
            Payments made to a Publisher through your use of the Payment Processing Service will be
            credited by the Publisher in accordance with the terms and conditions established by the
            Publisher. Please contact the Publisher for further information. We are not responsible
            for any delay with respect to when payments made to a Publisher will be credited to you,
            or any failure of a Publisher to accept or properly process any funds remitted to it.
            Once accepted by Tilia, you may not cancel a payment made through the Payment Processing
            Service or obtain a refund from Tilia for any such payment. In the event that you wish
            to obtain a refund of any payment made, you must contact the relevant Publisher, and the
            availability of any refund will be subject to the relevant Platform TOS and the
            determination of the relevant Publisher.
          </p>
          <p>By using the Payment Processing Service, you authorize Tilia to:</p>
          <ul role="list">
            <li>
              accept and remit payments made by you using the payment methods supported by Tilia for
              purchases or other transactions enabled for the particular Platform or for amounts
              owed to the relevant Publisher or user plus any applicable taxes Tilia is required to
              collect or fees owed to Tilia;
            </li>
            <li>
              provide your payment and/or account information, and any other information you have
              provided to Tilia, to the PSP you have selected as may be required to process your
              requested transaction;
            </li>
            <li>
              automatically charge, in accordance with the instructions you provide for any
              recurring payments, the credit or debit card or other payment method you have
              associated with your Tilia Account in order to pay recurring amounts to the relevant
              Publisher, as well as any applicable taxes Tilia is required to collect or fees owed
              to Tilia; and,
            </li>
            <li>maintain and utilize your PSP credentials, preferences, and log-in information.</li>
          </ul>
          <h2>
            <strong id="stored-value-balance">4. Stored Value Balance</strong>
          </h2>
          <h3>
            <strong>4.1. General</strong>
          </h3>
          <p>
            Tilia may offer a Stored Value Balance associated with your Tilia Account, which is a
            stored value account issued by Tilia in which you hold funds.{" "}
          </p>
          <p>
            The Stored Value Balance services provided to you by Tilia are a hosted digital balance
            maintained by Tilia enabling you to store funds or Earned Tokens (defined below)
            electronically (the &quot;<strong>Stored Value Balance</strong>
            &quot;); and certain payment services enabling you to do the following:
          </p>
          <blockquote>
            a) receive funds or Earned Tokens electronically in accordance with Section 4.2 below
            (i.e., funds can be received into the Stored Value Balance from you, other Platform
            users, the Publisher, or as a result of the exchange of Earned Tokens issued by Tilia on
            a Platform); and,
          </blockquote>
          <blockquote>
            b) redeem funds held in the Stored Value Balance in accordance with Section 4.3 below.
          </blockquote>
          <p>
            Depending on our arrangement with the Publisher, your Stored Value Balance may hold
            funds denominated in fiat or Earned Tokens, defined in Section 5 below, and we will show
            the balance that you hold, to the extent applicable. The default fiat for the Stored
            Value Balance will be United States Dollars (“<strong>USD</strong>
            ”).
          </p>
          <p>
            <strong>
              The use of each Stored Value Balance is limited to the Platform in connection with
              which it is issued, meaning that it may not be used to make payments to any other
              Publisher, or through any other Platform, with which the Tilia Service is integrated.
            </strong>
          </p>
          <p>
            You will not grant to any third party any security interest in your Stored Value
            Balance.
          </p>
          <h3>
            <strong>4.2. Crediting the Stored Value Balance</strong>
          </h3>
          <p>
            When you engage in activities on a Platform that enable you to earn compensation from
            the Publisher pursuant to the Platform TOS, e.g., creating Digital Goods, completing
            tasks, or otherwise enhancing the experience of a Platform, you are referred to as a
            “Creator” and such activity is hereinafter referred to as “Compensable Activity.”  Such
            compensation can be in the form of a load to your Stored Value Balance (or in the form
            of Earned Tokens, as defined below, in a token-based economy).
          </p>
          <p>
            Tilia will fund your Stored Value Balance as instructed by Publisher.  Funding will not
            take place until Tilia has successfully completed necessary checks to comply with
            applicable law and its internal risk management processes and only when funds to support
            the Stored Value Balance load have been received by Tilia from the Publisher.{" "}
          </p>
          <p>
            Depending on the Platform, you may also fund your Stored Value Balance denominated in
            fiat using any of our supported payment methods, which are set out and available on the
            Platform, such as credit or debit card or bank transfer.{" "}
          </p>
          <p>Any associated fees (if applicable) will be published on the Platform. </p>
          <p>
            Due to legal or regulatory reasons, we may need to impose certain restrictions on the
            methods you can use to pay money into your Stored Value Balance. We will try to keep you
            informed of any such changes.{" "}
          </p>
          <p>The Stored Value Balance is not a deposit or investment account. </p>
          <p>
            Fund we receive associated with your fiat-denominated Stored Value Balance will be
            deposited in a secure account, specifically for the purpose of redeeming transactions
            made from your Stored Value Balance. Funds will not be insured to you by the Federal
            Deposit Insurance Corporation or any other entity, and you will not be entitled to any
            interest with respect to such funds. In the event that we become insolvent, funds that
            you have loaded which have arrived with and been deposited by us are protected against
            the claims made by our creditors.
          </p>
          <h3>
            <strong>4.3. Withdrawals and Redemptions</strong>
          </h3>
          <p>
            Subject to compliance with applicable law and our risk management processes, You may
            redeem all or part of any fiat-denominated balance held in your Stored Value Balance at
            any time. With respect to a Stored Value Balance denominated in Earned Tokens, only
            Earned Tokens acquired from the completion of Compensable Activity may be redeemed for
            fiat, either to fund your fiat-denominated Stored Value Balance or to be paid out
            directly to Your external financial account.  Digital Tokens that are “unearned” may not
            be redeemed for fiat.
          </p>
          <p>
            Subject to compliance with applicable law and our risk management processes, funds will
            be transferred to your bank account or payment service provider which you have
            identified to us and which we support. For Earned Tokens, funds will be transferred to
            your Stored Value Balance denominated in fiat or may be sent directly to Your external
            financial account that is supported by Tilia.{" "}
            <strong>
              Prior to loading your Stored Value Balance denominated in fiat, it is your
              responsibility to determine if funds can be transferred to the relevant payment
              service provider as certain payment service providers (e.g., PayPal) do not offer
              services in every jurisdiction.{" "}
            </strong>
          </p>
          <p>
            We will charge a redemption fee (a “<strong>Redemption Fee</strong>
            ”) upon redemption of your Stored Value Balance. This fee is set out in the Fee Schedule
            published on the Website (which shall include the relevant Publisher platform).
          </p>
          <p>
            Prior to redeeming funds from your Stored Value Balance, we may conduct checks for the
            purposes of preventing fraud, money laundering, terrorist financing and other financial
            crimes. You may be prevented or delayed from withdrawing funds in the Stored Value
            Balance until those checks are completed to our reasonable satisfaction in order to
            comply with our regulatory requirements. If we find that you have been engaged in fraud,
            money laundering, terrorist financing or other financial crimes, you may lose all rights
            to any funds derived from such activity.{" "}
          </p>
          <p>
            The redemption request will be subject to a fee payable to Tilia, and the redemption
            will be processed within approximately five (5) to ten (10) business days following the
            request but may take up to thirty (30) days to process.
          </p>
          <p>
            If these Terms are terminated or your Tilia Account is closed for any reason, we will
            redeem any funds remaining in your Stored Value Balance and transfer funds to the
            external financial account you have registered with us.{" "}
          </p>
          <p>
            Tilia has a right of set-off; therefore, if you owe Tilia fees or any other amount, we
            are permitted to take the amount you owe us from your Stored Value Balance.
          </p>
          <p>
            You are responsible for paying taxes or costs that apply to payments you make or receive
            through your Stored Value Balance and Tilia is not responsible for collecting these from
            you.
          </p>
          <h3>
            <strong>4.4. Transactions Involving the Stored Value Balance</strong>
          </h3>
          <p>
            If applicable on a particular Platform, where a transaction is initiated from your
            Stored Value Balance using your security credentials, we will assume that you authorized
            such transaction, unless you notify us otherwise.
          </p>
          <p>
            If you believe that a transaction using your Stored Value Balance has been carried out
            that you did not authorize (an &quot;<strong>Unauthorized Transaction</strong>
            &quot;), or if you have reason to believe that a transaction using your Stored Value
            Balance has been incorrectly carried out or is not complete (an &quot;
            <strong>Incorrect Transaction</strong>
            &quot;), you must contact us as soon as possible.
          </p>
          <p>
            It is important that you regularly check your Stored Value Balance and your transaction
            history to ensure any Unauthorized Transactions or Incorrect Transactions are identified
            and notified to us at the earliest possible opportunity.
          </p>
          <p>
            We are not responsible for any claim for Unauthorized Transactions or Incorrect
            Transactions unless you have notified us in accordance with this Section 4.4, in which
            case we set out below our respective responsibilities.{" "}
          </p>
          <p>
            As further described below, we are not responsible for any claim for Unauthorized
            Transactions or Incorrect Transactions if you have acted fraudulently, intentionally,
            carelessly or with negligence and this has resulted in the Unauthorized Transactions or
            Incorrect Transactions.
          </p>
          <p>
            During any investigation of any actual or potential Unauthorized Transactions or
            Incorrect Transactions, we reserve the right to suspend your Stored Value Balance to
            avoid further losses.
          </p>
          <p>
            If an Unauthorized Transaction occurs as a result of Tilia’s failure, we will refund you
            the amount of that transaction by no later than the end of the next business day after
            becoming aware of the Unauthorized Transaction and restore your Stored Value Balance to
            the state it would have been in had the Unauthorized Transaction not taken place.
          </p>
          <p>
            Generally, you will not be liable for losses incurred after you have notified us of the
            Unauthorized Transaction or if we have failed at any time to provide you with the means
            for notifying us.
          </p>
          <p>
            We may charge you for the first $20 of any losses you incur in respect of an
            Unauthorized Transaction which arises from the use of lost or stolen credentials (for
            example when you have failed to keep the login details secure), and if you are
            fraudulent, or you intentionally or negligently fail to carry out your obligations under
            these Terms and this results in Unauthorized Transactions (for example, if you
            deliberately share your email and password with a third party, or are careless or
            negligent in keeping your email and password secure), you may be liable for all
            resultant losses incurred as a result of any such Unauthorized Transactions, not just
            the first $20.
          </p>
          <p>
            Where there is a dispute between us regarding whether or not a transaction is an
            Unauthorized Transaction, we may (but are not obliged to) temporarily credit your Stored
            Value Balance while we settle the dispute.{" "}
          </p>
          <p>
            Where we determine that the transaction was authorized, we may reverse that credit and
            correct errors made in any statement of Stored Value Balance without prior notice to
            you, although please note that during this period your Stored Value Balance may be
            temporarily locked to avoid further Unauthorized Transactions. You will also be liable
            to us (as a debt) for any funds you have transferred which were temporarily credited to
            your Stored Value Balance.
          </p>
          <p>
            Where an Incorrect Transaction is made because of our action or error we shall refund to
            you the amount of that transaction without undue delay and restore your Stored Value
            Balance to the state in which it would have been had the Incorrect Transaction not taken
            place. We will also endeavour to provide you with reasonable notice where possible. We
            will also pay any charges for which we are responsible. Irrespective of our liability,
            on your request, we shall try to trace any Incorrect Transaction initiated by you free
            of charge. However, we cannot guarantee that we will be able to trace such transactions.
          </p>
          <h2 id="digital-tokens">
            <strong>5. Digital Tokens</strong>
          </h2>
          <h3>
            <strong>5.1. Issuance</strong>
          </h3>
          <p>
            Where supported by the Publisher in a token-based economy, the Tilia Service may include
            Tilia issuing (or managing Publisher’s issuance of) digital tokens to you, which can be
            used to access services and content within a Platform (“<strong>Digital Tokens</strong>
            ”). Furthermore, Digital Tokens that are acquired by you engaging in Compensable
            Activities on an applicable Platform are “<strong>Earned Tokens</strong>” and deemed
            stored value in accordance with Section 4 (Stored Value Balances). If there are any
            inconsistencies between the two sections, then Section 4 controls. Digital Tokens which
            may only be used and redeemed for content and services within a Platform are deemed “
            <strong>Purchased Tokens</strong>
            .”  Purchased Tokens can never be redeemed for fiat and cannot be utilized outside the
            Platform for which they are created. Depending on a Platform, Digital Tokens may be used
            as a mechanism to track Compensable Activities. Earned Tokens and Purchased Tokens will
            have naming conventions that are specific to a Publisher’s Platform.
          </p>
          <p>
            The manner in which you obtain access or use the Digital Tokens will depend on the
            Publisher and will be disclosed to you by the Publisher in the Platform ToS or on the
            Website.
          </p>
          <h3>
            <strong>5.2. Accumulating Earned Tokens </strong>
          </h3>
          <p>
            As indicated above, in the case of token-based economies, Creators may also receive
            compensation in the form of Earned Tokens for Compensable Activities. Earned Tokens are
            issued by Tilia.  Earned Tokens may be redeemed for fiat (e.g., USD).{" "}
          </p>
          <h3>
            <strong>5.3. Using Digital Tokens </strong>
          </h3>
          <p>
            The use of each Digital Token is limited to the Platform in connection with which it is
            issued, meaning that it may not be used or transferred to any other Publisher, or
            through any other Platform, with which the Tilia Service is integrated.{" "}
          </p>
          <p>
            Digital Tokens may not be sublicensed, encumbered, conveyed or made subject to any right
            of survivorship or other disposition or use by operation of law or otherwise and you
            agree that any attempted disposition or use of such Digital Tokens in violation of these
            Terms is null and void.{" "}
          </p>
          <h3>
            <strong>5.4. Termination of Access to Digital Tokens</strong>
          </h3>
          <p>
            We may revoke or terminate your access to Digital Tokens (other than Earned Tokens) in
            the event that:
          </p>
          <blockquote>
            a) the Digital Token program is suspended or terminated by the relevant Publisher;
          </blockquote>
          <blockquote>
            b) we reasonably suspect or know that fraud or other illegal conduct is associated with
            your Tilia Account or your use of your Tilia Account or any aspects of the Tilia
            Service;
          </blockquote>
          <blockquote>c) you have breached the relevant Publisher’s terms of service;</blockquote>
          <blockquote>
            d) the Publisher of the relevant Platform directs us to terminate your access to Digital
            Tokens; and/or
          </blockquote>
          <blockquote>e) these Terms are terminated.</blockquote>
          <h2 id="disbursements">
            <strong>6. Disbursements</strong>
          </h2>
          <p>
            On Platforms where Publishers pay Creators directly for Compensable Activity, Tilia
            facilitates the transfer of funds from the Publisher to the Creator &#x27;s external
            financial account (each such transfer called a “Disbursement”). All Disbursements are
            made pursuant to instructions received by Tilia from the Publisher and are subject to
            applicable law and Tilia’s risk management processes.
          </p>
          <h2 id="intellectual-property">
            <strong>7. Intellectual Property and Licenses </strong>
          </h2>
          <h3>
            <strong>7.1. Our Content </strong>
          </h3>
          <p>
            The Tilia Service, and all of the content and technology used to provide it to you,
            including, without limitation, our Website, Tilia, all logos related to the Tilia
            Service, patents, copyrights, trademarks, service marks, trade names, and any other
            intellectual or other proprietary rights recognised in any jurisdiction (”
            <strong>Content</strong>
            ”) are owned or controlled by Tilia, our affiliates, licensors, or certain other third
            parties. All right, title, and interest in and to the Content is the property of Tilia,
            our affiliates, our licensors or certain other third parties, and is protected by
            copyright, trade mark, trade dress, patent and/or other intellectual property and unfair
            competition rights and laws to the fullest extent possible existing in the US and all
            other jurisdictions. Tilia owns the copyright in the selection, compilation, assembly,
            arrangement, and enhancement of the Content on the Tilia Service.
          </p>
          <h3>
            <strong>7.2. What you Own   </strong>
          </h3>
          <p>
            Throughout our relationship with you, you retain ownership of the details, information
            or other data you submit for your Tilia Account or through the use of the Tilia
            Services. You also have the right to grant the rights and licences in these Terms as
            further detailed below.
          </p>
          <h3>
            <strong>7.3. License to Us </strong>
          </h3>
          <p>
            In order for us to provide the Tilia Service to you to the best of our ability, you
            grant Tilia a worldwide, royalty-free, sublicensable, and transferable license to use,
            reproduce, distribute, create derivative works of, and display the information
            (including any content) that you upload, store, send, or receive on or through the use
            of the Tilia Services. We will only use such rights for the limited purpose of providing
            the Tilia Services.
          </p>
          <h3>
            <strong>7.4. License to You     </strong>
          </h3>
          <p>
            In order for you to receive the Tilia Services at the best standard, we grant you a
            revocable, non-exclusive, non-sublicenseable and non-transferable license to use the
            Tilia Services for the sole purpose for which they were created, subject to and in
            accordance with these Terms. No other licenses or rights are granted to you by
            implication or otherwise.
          </p>
          <h3>
            <strong>7.5. Infringement  </strong>
          </h3>
          <p>
            If you believe the intellectual property rights in our Content are being infringed by a
            third party, please contact us immediately using the contact details provided in these
            Terms. If we believe you are infringing the intellectual property rights in our Content
            or the intellectual property of another, we may terminate your Tilia Account and these
            Terms with immediate effect.
          </p>
          <h2 id="communications">
            <strong>8. Communications</strong>
          </h2>
          <h3>
            <strong>8.1. Communications from and to You</strong>
          </h3>
          <p>
            All notices given by you to Tilia or required under these Terms shall be mailed to the
            address found on this <a href="https://tiliapay.freshdesk.com/support/home" target="_blank">page</a>&nbsp;
            or emailed to <a href="mailto:support@thunes.com" target="_blank">support@thunes.com</a>.
          </p>
          <p>
            You acknowledge that to fully use the Tilia Service, we must be able to send to you
            electronically all communications, agreements, documents, notices and disclosures
            (collectively, &quot;Communications &quot;) that we provide in connection with the use
            of the Services. Communications include:
          </p>
          <blockquote>
            a) These Terms of use, including updates to these Terms as discussed above;
          </blockquote>
          <blockquote>
            b) account details, history, transaction receipts, confirmations, and any other account
            or transaction information;
          </blockquote>
          <blockquote>
            c) legal and/or, regulatory disclosures or statements we may be required to make
            available to you; and
          </blockquote>
          <blockquote>
            d) responses to claims or customer support inquiries filed in connection with your Tilia
            Account.
          </blockquote>
          <p>
            We will provide these Communications to you by posting them on the Tilia Website,
            emailing them to you at the primary email address listed in your Tilia Account, and/or
            through other electronic communication such as text message or mobile push notification.
          </p>
          <p>
            It is your responsibility to provide us with a true, accurate and complete email address
            and contact information, and to keep such information up to date. You understand and
            agree that if we send you an electronic Communication but you do not receive it because
            your primary email address on file is incorrect, out-of-date, blocked by your service
            Publisher, or you are otherwise unable to receive electronic Communications, we will be
            deemed to have provided the Communication to you.
          </p>
          <p>
            In addition to electronic communication, Tilia may communicate with you, including
            giving notice to or obtaining consent from you, through the Tilia Service or Website or
            by written mail communication to the address on record for your Tilia Account.
          </p>
          <p>
            For questions or complaints regarding payments made to Tilia or any other aspect of the
            Tilia Service, please contact Tilia Customer Service at <a href="mailto:support@thunes.com" target="_blank">support@thunes.com</a>. When
            contacting us by telephone, you will not be bound to pay more than the basic rate (i.e.,
            the simple cost of connection).
          </p>
          <h2>
            <strong id="term-and-termination">9. Term and Termination</strong>
          </h2>
          <h3>
            <strong>9.1. Term</strong>
          </h3>
          <p>
            These Terms shall commence on the date you receive confirmation from us of your
            successful application for Tilia Services and will continue until terminated by you, the
            Publisher, or Tilia.{" "}
          </p>
          <h3>
            <strong>9.2. Termination for Cause</strong>
          </h3>
          <p>
            We may: (a) refuse to complete, or block, cancel or reverse a transaction you have
            authorized (even after funds have been debited from your Stored Value Balance); (b)
            suspend, restrict, or terminate your access to any or all of the Tilia Service; and/or
            (c) deactivate or cancel your Tilia Account with immediate effect for cause, including
            but not limited to where:
          </p>
          <blockquote>
            i. we reasonably believe that we need to do so in order to protect our reputation;
          </blockquote>
          <blockquote>
            ii. we are, in our reasonable opinion, required to do so by applicable law, regulation
            or any court or other authority to which we are subject in any jurisdiction;
          </blockquote>
          <blockquote>
            iii. you breach an important part of these Terms, or repeatedly breach any provision in
            the Terms and ‎fail to resolve the matter in a timely manner;
          </blockquote>
          <blockquote>
            iv. we have concerns that a transaction is erroneous or about the security of your Tilia
            Account or Stored Value Balance or we suspect the Tilia Services are being used in a
            fraudulent or unauthorized manner;
          </blockquote>
          <blockquote>
            v. we suspect money laundering, terrorist financing, fraud, or any other financial
            crime;
          </blockquote>
          <blockquote>
            vi. we are unable to satisfy our due diligence requirements under applicable law;
          </blockquote>
          <blockquote>vii. you breach the relevant Publisher’s terms of service;</blockquote>
          <blockquote>
            viii. the Publisher of the relevant Platform directs Tilia to terminate your access to
            any aspect of the Tilia Service;
          </blockquote>
          <blockquote>
            ix. use of your Tilia Account or Stored Value Balance is subject to any pending
            litigation, investigation, or government proceeding and / or we perceive a heightened
            risk of legal or regulatory non-compliance associated with your activity; and / or
          </blockquote>
          <blockquote>x. you take any action that may circumvent our controls.</blockquote>
          <p>
            We may also refuse to complete or may block, cancel or reverse a transaction you have
            authorized where there are insufficient funds in your Stored Value Balance to cover the
            transaction and (where applicable) associated fees at the time that we receive
            notification of the transaction.{" "}
          </p>
          <p>
            <strong>9.3. Termination for Convenience</strong>
          </p>
          <p>
            We may suspend, restrict, or terminate your access to any or all of the Tilia Service
            and/or deactivate or cancel your Tilia Account, without reason by giving you two months’
            notice. In such event, any funds associated with your Tilia Account will be subject to
            redemption in accordance with Section 4.3.{" "}
          </p>
          <h3>
            <strong>9.4. Termination by Publisher</strong>
          </h3>
          <p>
            On receipt of notification by us from the Publisher that it wishes to terminate the
            Tilia Service, your use of the Tilia Service will also terminate.{" "}
          </p>
          <p>
            Any funds in your Stored Value Balance will be transferred to your external financial
            account in accordance with these Terms. You must pay immediately all outstanding fees
            due under these Terms and in the event of a negative balance in the Stored Value
            Balance, you must reimburse us such amount equal to the negative balance.
          </p>
          <h3>
            <strong>9.5. Termination – General</strong>
          </h3>
          <p>
            You acknowledge that our decision to take certain actions, including limiting access to,
            suspending, or closing your Tilia Account, may be based on confidential criteria that
            are essential for the purposes of our risk management and security protocols. You agree
            that we are under no obligation to disclose the details of our risk management and
            security procedures to you.
          </p>
          <p>
            You are not permitted to use the Tilia Services or your Tilia Account for any other
            purposes during these periods and we may, at our discretion, limit the functionality of
            the Website for you accordingly.
          </p>
          <p>
            If we suspend or close your Tilia Account or terminate your use of Tilia Services for
            any reason, we reserve the right to require you to re-complete the procedures outlined
            at Section 2.4 (Identity Verification) before permitting you to transfer funds.
          </p>
          <h3>
            <strong>9.6. Closing Your Tilia Account</strong>
          </h3>
          <p>
            You may close your Tilia Account at any time by following the instructions in your Tilia
            Account profile or terminating your account associated with the relevant Platform,
            unless prohibited by applicable law. Upon terminating your Tilia Account, we will cancel
            any transactions that you have pending, you will no longer be able to access the Tilia
            Service, and we will have no further obligation or liability to you under these Terms.
            Unless Tilia elects to process redemptions of the Stored Value Balance, you shall not be
            entitled to any compensation or other payment, remedy, recourse or refund upon
            terminating your Tilia Account. If you have funds associated with a Stored Value
            Balance, we will process redemptions at our discretion in accordance with Section 4.3.
          </p>
          <p>
            You may not close your Tilia Account to evade an investigation. If you attempt to close
            your Tilia Account while we are conducting an investigation, we may hold any unused
            funds associated with your Stored Value Balance for up to 180 days to protect Tilia, its
            affiliates, a Publisher, or any other third party against the risk of any reversals,
            chargebacks, claims, fees, fines, penalties, and other liability. You will remain liable
            for all obligations related to your Tilia Account even after your Tilia Account is
            closed.
          </p>
          <h3>
            <strong>9.7. Abandoned Property</strong>
          </h3>
          <p>
            If you leave funds in your Stored Value Balance unused for the period of time set forth
            by your state, country, or other governing body of residence in its unclaimed property
            laws, or if you close your Tilia Account and leave funds in your Stored Value Balance,
            or if we terminate your Tilia Account and you do not meet any conditions necessary to
            reinstate it within six (6) months, we may process your funds in accordance with our
            legal obligations, including by submitting your funds to the appropriate governing body
            as required by law.
          </p>
          <h2 id="fees">
            <strong>10. Fees</strong>
          </h2>
          <p>
            You agree to pay the applicable fees listed on our Fee Schedule published on the Website
            (which shall include the relevant Publisher platform) (”<strong>Fees</strong>
            ”) for use of the Tilia Service.
          </p>
          <p>
            Banks and other payment service providers may charge a transaction and/or foreign
            exchange fee on your transactions. You should check with your card issuer or payment
            service Publisher for further details.{" "}
          </p>
          <p>
            All Fees are charged at the time we process a transaction and are applied to the payment
            method you select. We reserve the right to change our Fees upon thirty (30) days’
            advance notice. By continuing to use the Tilia Service after a change in the Fees, you
            hereby agree to such change. All Fees, charges, and payments collected or paid are
            denominated in USD.
          </p>
          <h2>
            <strong id="customer-complaints">
              11. Customer Complaints – Money Transmission Activity
            </strong>
          </h2>
          <h3>
            <strong>11.1. Alaska Users</strong>
          </h3>
          <p>
            If your issue is unresolved by Tilia LLC (855) 983-4646, please submit formal complaints
            with the State of Alaska, Division of Banking &amp;Securities.{" "}
          </p>
          <p>
            Please download the form here:{" "}
            <a href="https://www.commerce.alaska.gov/web/portals/3/pub/DBSGeneralComplaintFormupdated.pdf" target="_blank">
              https://www.commerce.alaska.gov/web/portals/3/pub/DBSGeneralComplaintFormupdated.pdf
            </a>
          </p>
          <p>Submit formal complaint form with supporting documents:</p>
          <p>Division of Banking &amp;Securities PO Box 110807 Juneau, AK  99811-0807</p>
          <p>
            If you are an Alaska resident with questions regarding formal complaints, please email
            us at dbs.licensing@alaska.gov or call Nine Zero Seven Four Six Five Two Five Two One.
          </p>
          <h3>
            <strong>11.2. California Users</strong>
          </h3>
          <p>
            If you have complaints with respect to any aspect of the money transmission activities
            conducted at this location, you may contact the California Department of Financial
            Protection and Innovation at its toll-free telephone number, 1-866-275-2677, by e-mail
            at consumer.services@dbo.ca.gov, or by mail at the Department of Financial Protection
            and Innovation, Consumer Services, 2101 Arena Boulevard, Sacramento, CA 95834.
          </p>
          <h3>
            <strong>11.3. Florida Users</strong>
          </h3>
          <p>
            If you are a user in the State of Florida and you have an unresolved complaint regarding
            Tilia’s money transmission activity after first contacting Tilia, please direct your
            inquiry to: Florida Office of Financial Regulation, 200 E. Gaines Street, Tallahassee,
            FL 32399-0376. The Office of Financial Regulation’s toll-free telephone number is
            1-800-848-3792.
          </p>
          <h3>
            <strong>11.4. Maryland Users</strong>
          </h3>
          <p>
            The Commissioner of Financial Regulation for the State of Maryland will accept all
            questions or complaints from Maryland residents regarding Tilia Inc., license number
            1272156, at Commissioner of Financial Regulation, Attention: Consumer Services Unit, 500
            North Calvert Street, Suite 402, Baltimore, Maryland 21202. The Commissioner’s toll-free
            telephone number is: 1-888-784-0136.
          </p>
          <h3>
            <strong>11.5. Texas Users</strong>
          </h3>
          <p>
            If you have a complaint, first contact Tilia’s customer support by email at{" "}
            <a href="mailto:support@thunes.com" target="_blank">support@thunes.com</a>&nbsp;
            or by phone at 1-855-983-4646. If you still have an unresolved complaint regarding
            Tilia’s money transmission activity, please direct your complaint to the attention of:
            Texas Department of Banking, 2601 North Lamar Boulevard, Austin, Texas 78705;
            1-877-276-5554 (toll-free in the U.S.). Please visit{" "}
            <a href="http://www.dob.texas.gov" target="_blank">www.dob.texas.gov</a>&nbsp;
            for more information.
          </p>
          <h2>
            <strong id="releases-disclaimers-liability">
              12. Releases, Disclaimers, Liability Limits and Identification
            </strong>
          </h2>
          <h3>
            <strong>12.1. Release of Liability</strong>
          </h3>
          <p>
            Tilia does not control and is not responsible for anything other than the Tilia
            Services.  If you have a dispute regarding anything other than the Tilia Services
            provided to you by Tilia, including, but not limited to, any disputes with other users
            of the Tilia Service or Platform Publishers or regarding content on Platforms created or
            posted by other Platform users, neither we nor, our affiliates, and each of our, or
            their, respective officers, directors, agents, employees and representatives, will be
            liable for any claims, demands and damages (actual and consequential, direct or
            indirect) of any kind or nature arising out of or in any way connected with such
            disputes.
          </p>
          <p>
            If you are a California resident, you waive California Civil Code Section 1542, which
            says: &quot;A general release does not extend to claims which the creditor does not know
            or suspect to exist in his favor at the time of executing the release, which if known by
            him must have materially affected his settlement with the debtor.&quot;If you are a
            resident of another jurisdiction, you waive any comparable statute or doctrine.
          </p>
          <h3>
            <strong>12.2. Tilia Service Provided on an “As is” Basis</strong>
          </h3>
          <p>
            TILIA PROVIDES THE TILIA SERVICE, INCLUDING WITHOUT LIMITATION ANY SOFTWARE, PROGRAMS,
            DOCUMENTATION, TOOLS, INTERNET-BASED SERVICES, COMPONENTS, THE WEBSITE, TILIA’S SERVERS,
            ANY UPDATES TO ANY OF THE FOREGOING, AND YOUR ACCOUNT, STRICTLY ON AN “AS IS” BASIS, AND
            HEREBY EXPRESSLY DISCLAIMS ALL WARRANTIES OR CONDITIONS OF ANY KIND, WRITTEN OR ORAL,
            EXPRESS, IMPLIED OR STATUTORY, INCLUDING WITHOUT LIMITATION ANY IMPLIED WARRANTY OF
            TITLE, NONINFRINGEMENT, MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
          </p>
          <p>
            NO VALUE, EITHER EXPRESS OR IMPLIED, IS GUARANTEED OR WARRANTED WITH RESPECT TO ANY
            CONTENT, INCLUDING DIGITAL TOKENS OR STORED VALUE BALANCES.
          </p>
          <p>
            Tilia does not ensure continuous, error-free, secure or virus-free operation of the
            Tilia Service or any component thereof, the Website, Tilia &#x27;s servers (the
            &quot;Servers &quot;), or your Tilia Account, and you understand that you shall not be
            entitled to refunds or other compensation based on Tilia &#x27;s failure to provide any
            of the foregoing other than as explicitly provided in these Terms.
          </p>
          <p>
            Some jurisdictions do not allow the disclaimer of implied warranties and, to that
            extent, the foregoing disclaimers may not apply to you.
          </p>
          <h3>
            <strong>12.3. Tilia Service Interruptions and Data Loss</strong>
          </h3>
          <p>
            Tilia may on occasion need to interrupt the Tilia Service with or without prior notice.
             Tilia will, where possible, endeavour to provide prior notice. You agree that Tilia
            will not be liable for any interruption of the Tilia Service, and you understand that
            except as may otherwise be specifically provided in these Terms, you will not be
            entitled to any refunds of fees or other compensation for interruption of the Tilia
            Service. Likewise, in the event of data loss, we will not be liable for any purported
            damage or harm arising therefrom. Tilia owns the bits and bytes of electronic data
            stored on Tilia’s servers (the “Servers”), and accordingly will not be liable for any
            deletion, corruption or data loss that occurs in connection with the Tilia Service.
            Tilia will solely determine any disposition of the electronic data stored on the Servers
            and will have no obligation to reproduce, process, transfer, extract or recreate any
            data from the Servers, except in accordance with applicable law.
          </p>
          <p>
            The Tilia Service is subject to scheduled and unscheduled service interruptions and loss
            of server data, which you do not own and for which you will not hold us liable.
          </p>
          <h3>
            <strong>12.4. Limited Liability</strong>
          </h3>
          <p>
            Tilia’s total aggregate liability to you for any individual claim or series of connected
            claims for losses, costs, liabilities or expenses which you may suffer arising out of,
            or in connection with, any breach by Tilia of these Terms shall be limited to a maximum
            aggregate value of the funds held in your Stored Value Balance at the time of the
            relevant claim. Where we are considering a specific claim relating to a specific
            transaction this sum shall be further limited to the purchase / sale amount (as
            relevant) of the transaction in dispute.
          </p>
          <p>
            In addition to the liability cap in this Section 12.4, in no event shall we, our
            affiliates or service Publishers, or any of our or their respective officers, directors,
            agents, employees or representatives, be liable for any of the following types of loss
            or damage arising under or in connection with these Terms or otherwise:
          </p>
          <blockquote>a) consequential, indirect or special losses or damages; </blockquote>
          <blockquote>
            b) loss of profits, loss of business or loss of business opportunity;
          </blockquote>
          <blockquote>
            c) loss as a result of any failed payment due to insufficient funds in your Tilia
            Account;
          </blockquote>
          <blockquote>
            d) losses incurred as a result of abnormal or unforeseeable circumstances outside our
            reasonable control, including delays or failures caused by problems of another system or
            network, mechanical breakdown, industrial action or a pandemic;{" "}
          </blockquote>
          <blockquote>
            e) losses incurred where a law, or guidance or instruction from an governmental
            authority, requires us to take action, for example to terminate these Terms and close
            your Tilia Account; or
          </blockquote>
          <blockquote>
            f) any other loss or damage to the extent that such loss or damage is caused or
            contributed to by you, or is a result of the failure by you to comply with these Terms.
          </blockquote>
          <p>
            The limitation of liability in this Section 12.4 is subject to any obligations that we
            have under applicable law and regulation, including our obligation to exercise
            reasonable care and skill in our provision of the Tilia Service. Nothing in these Terms
            shall limit our liability resulting from our fraud or fraudulent misrepresentation or
            for death or personal injury resulting from either our or our subcontractors’
            negligence.
          </p>
          <p>
            <strong>12.5. Indemnity</strong>
          </p>
          <p>
            You agree to indemnify us, our affiliates and service providers, and each of our, or
            their, respective officers, directors, agents, employees and representatives, in respect
            of any costs (including attorneys &#x27;fees and any fines, fees or penalties imposed by
            any regulatory authority) that have been reasonably incurred in connection with any
            claims, demands or damages arising out of or related to your breach and / or our
            enforcement of these Terms or your violation of any law, rule or regulation, or the
            rights of any third party.
          </p>
          <h2>
            <strong id="dispute-resolution">13. Dispute Resolution and Arbitration</strong>
          </h2>
          <h3>
            <strong>13.1. Notifications of Dispute</strong>
          </h3>
          <p>
            Our goal is to provide you with a neutral and cost-effective means of resolving the
            dispute quickly. If any controversy, allegation or claim arises out of or relates to the
            Tilia Service, the Website(s), the Content, these Terms, your decision to enter into
            these Terms, or any Additional Terms (collectively, “<strong>Dispute</strong>
            ”), then you and we agree to send a written notice to the other providing a reasonable
            description of the Dispute, along with a proposed resolution of it. Our notice to you
            will be sent to you based on the most recent contact information that you provide us.
            However, if no such information exists or if such information is not current or correct,
            then we have no obligation under this section. Your notice to us must be sent to: Tilia
            Inc., 548 Market St. PMB 59201, San Francisco, California 94104-5401 US, Attention:
            General Counsel. For a period of sixty (60) days from the date of receipt of notice from
            the other party, Tilia and you will engage in a dialogue in order to attempt to resolve
            the Dispute, though neither party is required to resolve such dispute on terms which
            each party, in its sole discretion, is uncomfortable. Arbitration Procedure
          </p>
          <p>
            IF WE CANNOT RESOLVE A DISPUTE WITHIN SIXTY (60) DAYS OF RECEIPT OF SUCH NOTICE, THEN
            EITHER YOU OR WE MAY ELECT TO SUBMIT THE DISPUTE TO FORMAL ARBITRATION AS HEREINAFTER
            DESCRIBED. WITH ARBITRATION (A) THERE IS NO JUDGE OR JURY, (B) THE ARBITRATION
            PROCEEDINGS AND ARBITRATION OUTCOME ARE SUBJECT TO CERTAIN CONFIDENTIALITY RULES, AND
            (C) JUDICIAL REVIEW OF THE ARBITRATION OUTCOME IS LIMITED.
          </p>
          <p>
            Further, you and Tilia agree that, should resolution of the Dispute(s) occur in
            arbitration, such Dispute(s) will be arbitrated only on an individual basis and will not
            be consolidated with any other arbitration or other proceedings that involve any claim
            or controversy of any other party. But if, for any reason, any court with competent
            jurisdiction or any arbitrator selected pursuant to this arbitration provision holds
            that this restriction, limiting the arbitration to Dispute(s) between you and Tilia, is
            unenforceable, then our agreement above to arbitrate will not apply and the Dispute must
            be brought exclusively in court pursuant to Section 14.5 (Law and Venue).
          </p>
          <p>
            Should either you or Tilia elect to resolve the Dispute by way of binding arbitration,
            the arbitration shall proceed in accordance with the then-current Commercial Arbitration
            Rules of the American Arbitration Association (&quot;<strong>AAA</strong>
            &quot;), except that in no event shall the arbitration proceed as a class or
            representative action. If the Dispute has a claimed value of not more than $10,000,000,
            then the arbitration will be heard and determined by a single, neutral arbitrator who is
            a retired judge or a lawyer with not less than ten (10) years &#x27;experience as a
            practicing member of the bar in the substantive practice area related to the Dispute,
            who will administer the proceedings in accordance with the AAA &#x27;s Supplementary
            Procedures for Consumer Related Disputes. If the Dispute has a claimed value of more
            than $10,000,000, then the arbitration will be heard and determined by a three (3)
            member panel, with one member to be selected by each party and the third (who will chair
            the panel) selected by the two (2) party-appointed members or by the AAA in accordance
            with the Commercial Arbitration Rules. The arbitrator or arbitration panel, as the case
            may be, will apply applicable law and the provisions of these Terms and any Additional
            Terms, will determine any Dispute according to applicable law and facts based upon the
            record and no other basis, and will issue a reasoned award.
          </p>
          <p>
            If a party properly submits the Dispute to the AAA for formal arbitration and the AAA is
            unwilling or unable to set a hearing date within sixty (60) days of the filing of a
            &quot;demand for arbitration,&quot;then either party can elect to have the arbitration
            administered by the Judicial Arbitration and Mediation Services Inc. (&quot;
            <strong>JAMS</strong>
            &quot;) using JAMS &#x27;streamlined Arbitration Rules and Procedures, or by any other
            arbitration administration service that you and a legal officer of Tilia consent to in
            writing, except, as noted above, that in no event shall the arbitration proceed as a
            class or representative action. The substantive practice area requirements for the
            arbitrator and the $10,000,000 threshold for the number of arbitrators assigned to the
            Dispute set forth in the paragraph above will also apply to any such arbitration under
            JAMS or other arbitration service.
          </p>
          <p>You can obtain AAA and JAMS procedures, rules, and fee information as follows:</p>
          <p>
            AAA: 1.800.778.7879 or <a href="https://www.adr.org/" target="_blank">www.adr.org</a>
          </p>
          <p>
            JAMS: 1.800.352.5267 or <a href="https://www.jamsadr.com/" target="_blank">www.jamsadr.com</a>
          </p>
          <p>
            All parties to the arbitration will have the right, at their own expense, to be
            represented by an attorney or other advocate of their choosing. If the Dispute has a
            claimed value of not more than $250,000, an arbitration hearing will be conducted, at
            your election, either by telephone (or other mutually agreeable remote technology) or in
            the City and County of San Francisco, California. If the Dispute has a claimed value of
            more than $250,000, the arbitration will be conducted in the City and County of San
            Francisco, California. You and we will pay the administrative and arbitrator &#x27;s
            fees and other costs in accordance with the applicable arbitration rules (including any
            rules regarding hardship); but if applicable arbitration rules or laws require Tilia to
            pay a greater portion or all of such fees and costs in order for this arbitration
            provision to be enforceable, or if the arbitrator(s) determine that you would experience
            an extreme hardship by paying your share of arbitration fees and costs prior to
            resolution of the Dispute, then Tilia will have the right to elect to pay the fees and
            costs and proceed to arbitration. Discovery will be permitted pursuant to the applicable
            arbitration rules. The arbitrator &#x27;s decision must consist of a written statement
            stating the disposition of each claim of the Dispute and must provide a statement of the
            essential findings and conclusions on which the decision and award (if any) may be
            entered in or by any court that has jurisdiction over the parties pursuant to Section 9
            of the Federal Arbitration Act. The arbitrator must honor the terms of these Terms (and
            any Additional Terms) and can award the prevailing party damages and other relief
            (including attorneys &#x27;fees) consistent with applicable law.
          </p>
          <h2>
            <strong id="general-provisions">14. General Provisions</strong>
          </h2>
          <h3>
            <strong>14.1. Amendments</strong>
          </h3>
          <p>
            We may change these Terms at any time in our sole discretion to the extent permitted by
            law. If we modify these Terms, we will post the modification on the Website and/or
            provide you notice of the modification by email or conspicuous notification, such as a
            popup, on the Platform and, in the event any such modifications decrease your rights or
            increase your obligations, will do so prior to such modification taking effect.
          </p>
          <p>
            When we change these Terms, the then-current version of these Terms supersedes all prior
            versions and governs your access to and use of the Tilia Service. If you continue to
            maintain your Tilia Account or use any portion of the Tilia Service following any
            change, you are deemed to have accepted and agreed to any changes, as of the effective
            date of any such change. If you do not wish to be bound to the changes, you must close
            your Tilia Account (see Section 9.6 for details) and cease using the Tilia Service.{" "}
          </p>
          <p>
            If any part of these Terms are inconsistent with any legal requirements then we will not
            rely on that part but treat it as if it did actually reflect the relevant legal
            requirement. If we need to make operational changes before we can fully comply with the
            new regulatory requirement, we will make those changes as soon as reasonably practical.
          </p>
          <p>
            You can obtain a copy of the current Terms{" "}
            <a href={TOS_URL} target="_blank">here</a>&nbsp;
            {/* <a href="/legal/terms-of-service/branch_terms-of-service" target="_blank">here</a> */}
            or by e-mailing a request to us at <a href="mailto:support@thunes.com" target="_blank">support@thunes.com</a>.
          </p>
          <h3>
            <strong>14.2. Entire Understanding and Agreement</strong>
          </h3>
          <p>
            Any headings or descriptive summary sentences contained in these Terms are for
            convenience only and shall not affect the interpretation of these Terms. Additionally,
            the terms “include” and “including” are not limiting. As used in these Terms, references
            to a determination made in Tilia’s discretion means that the determination will be made
            by Tilia in accordance with its good faith business judgment. If any provision of these
            Terms shall be held by a court of competent jurisdiction to be unlawful, void, or
            unenforceable, then in such jurisdiction that provision shall be deemed severable from
            these terms and shall not affect the validity and enforceability of the remaining
            provisions.
          </p>
          <p>
            These Terms (including documents incorporated by reference herein) comprise the entire
            understanding and agreement between you and us as to the subject matter hereof, and
            supersede any and all prior discussions, agreements and understandings of any kind
            (including without limitation any prior versions of these Terms), and every nature
            between and among you and Tilia.
          </p>
          <h3>
            <strong>14.3. Assignment</strong>
          </h3>
          <p>
            You may not transfer or assign any rights or obligations you have under these Terms
            without our prior written consent. You may not transfer or sublicense any licenses
            granted by Tilia in these Terms without our prior written consent.{" "}
          </p>
          <p>
            We may transfer or assign our rights licences, interests and/or our obligations at any
            time, including as part of a merger, acquisition or other corporate reorganisation
            involving Tilia, provided that this transfer or assignment does not materially impact
            the quality of the Tilia Service you receive. Subject to the foregoing, the Terms will
            bind and inure to the benefit of the parties, their successors and permitted assigns.
          </p>
          <p>
            In the event that Tilia is acquired by or merged with a third party entity, we reserve
            the right, in any of these circumstances, to transfer or assign the information we have
            collected from you and our relationship with you (including these Terms) as part of such
            merger, acquisition, sale, or other change of control.
          </p>
          <h3>
            <strong>14.4. Inconsistency</strong>
          </h3>
          <p>
            In the event of a conflict or inconsistency of a provision in these Terms and a
            provision in any other document or agreement, the provision that is most favourable to
            Tilia shall govern and control.
          </p>
          <p>
            If any provision of these Terms is determined to be invalid or unenforceable under any
            applicable law, this will not affect the validity of any other provision. If any
            provision is found unenforceable, the unenforceable provision will be severed, and the
            remaining provisions will be enforced.
          </p>
          <p>
            We may not always strictly enforce our rights under these Terms. If we do choose not to
            enforce our rights at any time, this is a temporary measure and we may enforce our
            rights strictly again at any time.
          </p>
          <h3>
            <strong>14.5. Law and Venue</strong>
          </h3>
          <p>
            These Terms and the relationship between us shall be governed by the laws of the State
            of California without regard to conflict of law principles or the United Nations
            Convention on the International Sale of Goods. Further, you and Tilia agree to submit to
            the exclusive personal jurisdiction and venue of the courts located in the City and
            County of San Francisco, California, except as provided in Section 13 regarding
            arbitration.
          </p>
          <p>
            These Terms and any information or notifications that you or we are to provide should be
            in English. Any translation of these Terms or other documents is provided for your
            convenience only and may not accurately represent the information in the original
            English. In the event of any inconsistency, the English language version of these Terms
            or other documents shall prevail.
          </p>
          <p>
            All provisions of these Terms which by their nature extend beyond the expiration or
            termination of these Terms, including, without limitation, the Sections relating to
            suspension or termination, the Tilia Account cancellation, debts owed to Tilia, general
            use of the Website, disputes with Tilia, and general provisions will continue to be
            binding and operate after the termination or expiration of these Terms.
          </p>
          <h3>
            <strong>14.6. No Equitable or Injunctive Relief</strong>
          </h3>
          <p>
            IF YOU CLAIM THAT YOU HAVE INCURRED ANY LOSSES OR DAMAGES IN CONNECTION WITH YOUR USE OF
            THE TILIA SERVICE, THEN THE LOSSES AND DAMAGES WILL NOT BE IRREPARABLE OR SUFFICIENT TO
            ENTITLE YOU TO AN INJUNCTION OR OTHER EQUITABLE RELIEF OF ANY KIND. THIS MEANS THAT, IN
            CONNECTION WITH YOUR CLAIM, YOU AGREE THAT YOU WILL NOT SEEK AND THAT YOU WILL NOT BE
            PERMITTED TO OBTAIN ANY COURT OR OTHER ACTION THAT MAY INTERFERE WITH OR PREVENT THE
            DEVELOPMENT OR EXPLOITATION OF ANY WEBSITE, CONTENT, PRODUCT, TILIA SERVICE, PLATFORM,
            PROVIDER OR OTHER INTELLECTUAL PROPERTY OWNED, LICENSED, OR CONTROLLED BY TILIA OR A
            LICENSOR OF TILIA.
          </p>
          <h3>
            <strong>14.7. Attorneys’ Fees and Costs</strong>
          </h3>
          <p>
            All claims you bring against Tilia must be resolved in accordance with Section 13,
            Dispute Resolution and Arbitration, except as expressly provided therein. All claims
            filed or brought contrary to the Dispute Resolution and Arbitration section shall be
            considered improperly filed and a breach of these Terms of Service. Should either party
            file a claim contrary to the Dispute Resolution and Arbitration section, the other party
            may recover attorneys’ fees and costs up to one thousand USD ($1,000.00 USD), provided
            that such party seeking such fees has notified the other in writing of the improperly
            filed claim, and the other has failed to promptly withdraw the claim.
          </p>
        </aside>
      </div>
    </section>
  );
};

const TermsOfService = () => {
  return (
    <PublisherThemeConfigProvider>
      <PublisherThemeExtendedChakraProvider>
        <TermsOfServiceContent />
      </PublisherThemeExtendedChakraProvider>
    </PublisherThemeConfigProvider>
  );
};

export default TermsOfService;
